module.exports = __webpack_public_path__ + "static/img/horizontalLogo.d7cd283.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/horizontalLogo.png
// module id = 129
// module chunks = 2